// Action Types
export const ActionTypes = {
  //cart.js
  CALC_PRICE: 'CALC_PRICE',
  //areas.js
  ADD_AREA_TO_LIST: 'ADD_AREA_TO_LIST',
  REMOVE_AREA_FROM_LIST: 'REMOVE_AREA_FROM_LIST',
  SET_ROOT_AREA_ID: 'SET_ROOT_AREA_ID',
  CHANGE_AREA_NUM: 'CHANGE_AREA_NUM',
  CHANGE_AREAS_HOUSE_TYPE: 'CHANGE_AREAS_HOUSE_TYPE',
  ERROR_AREAS: 'ERROR_AREAS',
	RESET_AREAS_DIALOG: 'RESET_AREAS_DIALOG',
  //options.js
  GET_INITIAL_OPTIONS: 'GET_INITIAL_OPTIONS',
  SELECT_OPTIONS: 'SELECT_OPTIONS',
  UPDATE_OPTIONS: 'UPDATE_OPTIONS',
  ERROR_OPTIONS: 'ERROR_OPTIONS',
  SET_AREA_NOTE: 'SET_AREA_NOTE',
  //clendar.js
  GET_CALENDAR: 'GET_CALENDAR',
  SELECT_CALENDAR_DATE: 'SELECT_CALENDAR_DATE',
  SET_CALENDAR_MODE: 'SET_CALENDAR_MODE',
  GET_CALENDAR_RULES: 'GET_CALENDAR_RULES'
};

// Product Types
export const ProductTypes = {
  // PrintFlyer:101,
  PostingFlyer: 102,
  SetPackFlyer: 103,
  // PrintPostCard:201,
  SetPackPostCard: 203,
  // PrintPoster:301,
  // PrintShopCard:401,
  // PrintClearFile:501,
  // PrintBooklet:601,
  // PrintPocketTissue:701,
  // PrintFan:801,
  // DM:901,
  // DMInnerItem:902,
  SetPackRecruit: 113
  // Rice:101,
};

// RootAreaIds
// export const RootAreaIds = {
//     KANTO: -1,
//     TOKAI: -2,
//     KINKI: -3,
// }
export const DefaultRootAreas = [
  {
    name: '関東',
    id: -1,
    bounds: {
      min: {
        lat: 35.13719,
        lng: 138.915817
      },
      max: {
        lat: 36.714608,
        lng: 140.716743
      }
    }
  },
  {
    name: '東海',
    id: -2,
    bounds: {
      min: {
        lat: 34.578109,
        lng: 136.671033
      },
      max: {
        lat: 35.645957,
        lng: 139.013832
      }
    }
  },
  {
    name: '近畿',
    id: -3,
    bounds: {
      min: {
        // lat: 34.299244,
        lat: 34.75181,
        // lng: 135.188132
        lng: 134.74254
      },
      max: {
        lat: 34.976756,
        // lng: 135.746603
        lng: 135.879924
      }
    }
  },
  {
    name: '宮城',
    id: -4,
    bounds: {
      min: {
        lat: 38.173994,
        lng: 140.469498
      },
      max: {
        lat: 38.496929,
        lng: 141.059497
      }
    }
  },
  {
    name: '広島',
    id: -5,
    bounds: {
      min: {
        lat: 34.261363,
        lng: 132.036448
      },
      max: {
        lat: 34.614767,
        lng: 132.696098
      }
    }
  },
  {
    name: '福岡',
    id: -6,
    bounds: {
      min: {
        lat: 33.424959,
        lng: 130.197804
      },
      max: {
        lat: 33.712544,
        lng: 130.514576
      }
    }
  }
];

// export const CalendarModeIds = {
//   NORMAL: 0,
//   FUKUOKA: 1,
//   KYOTO: 2
// };

// 配布カレンダー特殊モード
// export const CalendarModeAreaIds = [
//   // 1. 福岡モード
//   [82155],
//   // 2. 京都・広島モード
//   [84000]
// ];

// CancelTokenIds
export const CancelTokenIds = {
  INITALIZE_AREAS: 0,
  // GET_AREA_CHILDREN: 1,
  GET_JSON_TO_MAP: 1
};

// Option Types
export const OptionTypes = {
  HOUSE_NONE: 'n',
  HOUSE_SINGLE: 's',
  HOUSE_COMPLEX: 'c',
  SPEED_TYPE_SLOW: 1,
  SPEED_TYPE_SPEED: 2,
  SPEED_TYPE_SLOW_DAYS: 28,
  SPEED_TYPE_SPEED_DAYS: 7
};

// CSS values
export const CssValues = {
  CALENDAR_PAGE_WIDTH: 400
};



// WEBPACK FOOTER //
// ./src/constants.js